import { combineReducers, applyMiddleware, compose, createStore} from 'redux';
import { configureStore } from '@reduxjs/toolkit'; 
import thunk from 'redux-thunk';
import {reduxLib} from 'lib.front';
import appReducer from './appGen';
import constantesReducer from './constantes';
import {
   SLICE_APP_GEN,
   SLICE_AUTH,
   SLICE_CONSTANTES,
   SLICE_LOADING,
   SLICE_MODAL,
   SLICE_MSG,
   SLICE_OVERLAY,
   SLICE_SIDEBAR
} from './slices';

const rootReducer = combineReducers({
   [SLICE_AUTH]: reduxLib.auth.reducer,
   [SLICE_LOADING]: reduxLib.loading.reducer,
   [SLICE_MODAL]: reduxLib.modal.reducer,
   [SLICE_MSG]: reduxLib.msg.reducer,
   [SLICE_OVERLAY]: reduxLib.overlay.reducer,
   [SLICE_SIDEBAR]: reduxLib.sidebar.reducer,
   [SLICE_APP_GEN]: appReducer,
   [SLICE_CONSTANTES]: constantesReducer
});
const store = configureStore({
  reducer: rootReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false
    }).concat(thunk),
  devTools: process.env.NODE_ENV !== 'production',
});
export default store;
